var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-pencil-ruler",
      show: _vm.dialog,
      maxWidth: "40%",
      disabledSave: _vm.tab == 1,
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-tabs",
              {
                staticClass: "ma-0",
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c("v-tab", { key: "data" }, [_vm._v("Dados")]),
                _c(
                  "v-tab",
                  { key: "positions", attrs: { disabled: !_vm.model.id } },
                  [_vm._v("Posição Categoria")]
                ),
              ],
              1
            ),
            _c(
              "v-tabs-items",
              {
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c(
                  "v-tab-item",
                  { key: "data" },
                  [
                    _c(
                      "v-container",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "8" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    autofocus: "",
                                    error: !!_vm.errors.name,
                                    "error-messages": _vm.errors.name,
                                    label: "Nome*",
                                  },
                                  model: {
                                    value: _vm.model.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "name", $$v)
                                    },
                                    expression: "model.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    error: !!_vm.errors.initials,
                                    "error-messages": _vm.errors.initials,
                                    label: "Abreviação*",
                                  },
                                  model: {
                                    value: _vm.model.initials,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "initials", $$v)
                                    },
                                    expression: "model.initials",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("sys-select-hour-group", {
                                  attrs: {
                                    model: _vm.model.hour_group_id,
                                    error: _vm.errors.length > 0,
                                    errors: _vm.errors.hour_group_id,
                                    clearable: "",
                                    label: "Grupo de Horário",
                                  },
                                  on: {
                                    "update:model": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "hour_group_id",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("sys-select-ambience-type", {
                                  attrs: {
                                    model: _vm.model.ambience_type_id,
                                    error: _vm.errors.length > 0,
                                    errors: _vm.errors.ambience_type_id,
                                    clearable: "",
                                    label: "Tipo de Ambiente",
                                  },
                                  on: {
                                    "update:model": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "ambience_type_id",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "2" } },
                              [
                                _c("s-text-field", {
                                  attrs: {
                                    "text-helper": "Vagas Padrão",
                                    "error-messages": _vm.errors.students_max,
                                    label: "Vagas",
                                  },
                                  model: {
                                    value: _vm.model.students_max,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "students_max", $$v)
                                    },
                                    expression: "model.students_max",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm.isAnima()
                              ? _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "3" } },
                                  [
                                    _c("s-text-field", {
                                      attrs: {
                                        "error-messages": _vm.errors.position,
                                        label: "Posição",
                                      },
                                      model: {
                                        value: _vm.model.position,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.model, "position", $$v)
                                        },
                                        expression: "model.position",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("s-text-field", {
                                  attrs: {
                                    "text-helper":
                                      "Coluna referência para integração com o Totvs",
                                    code: "",
                                    "error-messages": _vm.errors.column_ref,
                                    label: "Referência",
                                  },
                                  model: {
                                    value: _vm.model.column_ref,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "column_ref", $$v)
                                    },
                                    expression: "model.column_ref",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "3" } },
                              [
                                _c("s-text-field", {
                                  attrs: {
                                    code: "",
                                    "error-messages": _vm.errors.code,
                                    label: "Código",
                                  },
                                  model: {
                                    value: _vm.model.code,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "code", $$v)
                                    },
                                    expression: "model.code",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("v-switch", {
                                  attrs: {
                                    inset: "",
                                    label: "Carga Horária Digital",
                                  },
                                  model: {
                                    value: _vm.model.digital,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "digital", $$v)
                                    },
                                    expression: "model.digital",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("v-switch", {
                                  attrs: { inset: "", label: "Com Professor" },
                                  model: {
                                    value: _vm.model.has_teacher,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "has_teacher", $$v)
                                    },
                                    expression: "model.has_teacher",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("v-switch", {
                                  attrs: {
                                    inset: "",
                                    label: "Carga Horária Paga",
                                  },
                                  model: {
                                    value: _vm.model.has_paid_workload,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "has_paid_workload",
                                        $$v
                                      )
                                    },
                                    expression: "model.has_paid_workload",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("v-switch", {
                                  attrs: { inset: "", label: "Possui Horário" },
                                  model: {
                                    value: _vm.model.has_time_table,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "has_time_table", $$v)
                                    },
                                    expression: "model.has_time_table",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("v-switch", {
                                  attrs: {
                                    inset: "",
                                    label: "Possui Ambiente",
                                  },
                                  model: {
                                    value: _vm.model.has_ambience,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "has_ambience", $$v)
                                    },
                                    expression: "model.has_ambience",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("v-switch", {
                                  attrs: { inset: "", label: "Padrão" },
                                  model: {
                                    value: _vm.model.default,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "default", $$v)
                                    },
                                    expression: "model.default",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("v-switch", {
                                  attrs: { inset: "", label: "Divisível" },
                                  model: {
                                    value: _vm.model.is_divisible,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "is_divisible", $$v)
                                    },
                                    expression: "model.is_divisible",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("s-switch", {
                                  attrs: {
                                    inset: "",
                                    "text-helper":
                                      "Permitir sobreposição de aulas na tela do horário",
                                    label: "Sobreposição",
                                  },
                                  model: {
                                    value: _vm.model.allow_overlap,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "allow_overlap", $$v)
                                    },
                                    expression: "model.allow_overlap",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("s-switch", {
                                  attrs: {
                                    inset: "",
                                    "text-helper":
                                      "Gerar oferta automaticamente desse tipo de carga horária",
                                    label: "Gerar Oferta",
                                  },
                                  model: {
                                    value: _vm.model.generate_offer,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "generate_offer", $$v)
                                    },
                                    expression: "model.generate_offer",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("s-switch", {
                                  attrs: {
                                    inset: "",
                                    "text-helper":
                                      "Tipo de Carga Horária Prática",
                                    label: "Prática",
                                  },
                                  model: {
                                    value: _vm.model.is_practice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "is_practice", $$v)
                                    },
                                    expression: "model.is_practice",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("s-switch", {
                                  attrs: { inset: "", label: "Ativa" },
                                  model: {
                                    value: _vm.model.active,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "active", $$v)
                                    },
                                    expression: "model.active",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm.isAnima()
                              ? _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "6" } },
                                  [
                                    _c("s-switch", {
                                      attrs: {
                                        inset: "",
                                        label: "Gerar Divisão",
                                        "text-helper":
                                          "Dividir grade em principal e secundário quando transformar o catálogo em oferta",
                                      },
                                      model: {
                                        value: _vm.model.generate_division,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "generate_division",
                                            $$v
                                          )
                                        },
                                        expression: "model.generate_division",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("s-switch", {
                                  attrs: {
                                    "text-helper":
                                      "Exibir atribuições separadamente na folha de ponto e sem exibir horário",
                                    inset: "",
                                    label: "Folha de Ponto Separada",
                                  },
                                  model: {
                                    value: _vm.model.show_separate_time_sheet,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "show_separate_time_sheet",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "model.show_separate_time_sheet",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-tab-item",
                  { key: "positions" },
                  [
                    _vm.model.id
                      ? _c("WorkLoadTypePositions", {
                          attrs: { "work-load-type-id": _vm.model.id },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }